/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./withdrawstat.vue?vue&type=template&id=2c5726f0&scoped=true"
import script from "./withdrawstat.vue?vue&type=script&lang=js"
export * from "./withdrawstat.vue?vue&type=script&lang=js"
import style0 from "./withdrawstat.vue?vue&type=style&index=0&id=2c5726f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5726f0",
  null
  
)

export default component.exports